import React, { useState, useEffect, useRef } from 'react';
import CommonSelect from '../../../components/Dashboard-res/CommonComponent/CommonSelect';
import CommonInput from '../../../components/Dashboard-res/CommonComponent/CommonInput';
import initialImg from '../../../images/icons/upload_new.svg';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import RadioButton from '../../../components/Dashboard-res/CommonComponent/RadioButton';
import { ShowGetImage } from '../../../common/components/ShowGetImage/ShowGetImage';
import _ from 'lodash';
import './ProfessionalDetails.css';
import {
  Salary_experience_year,
  Salary_experience_month
} from './ProfessionOptions';
import get from 'lodash/get';
import { useFormikContext } from 'formik';
import styles from './IncomeDetails.module.css';
import {
  EmpDocUpload,
  UploadFileToS3,
  EmpDocUploaded,
  submitDetails,
  getIndustryTypeProfessionDetail,
  getProfessionDetails,
  getCompanies,
  getCompanyTypeList,
  getCompanyNameByGst
} from '../../../common/constants/api';
import Modal from '../../../common/components/Modal/modal';

let qualificationOption = [
  {
    label: 'Secondary',
    value: 'Secondary'
  },
  {
    label: 'Higher Secondary',
    value: 'Higher Secondary'
  },
  {
    label: 'Diploma',
    value: 'Diploma'
  },
  {
    label: 'Graduation',
    value: 'Graduation'
  },
  {
    label: 'Post Graduation',
    value: 'Post Graduation'
  },
  {
    label: 'M. Phil',
    value: 'M. Phil'
  },
  {
    label: 'Doctrate (PhD)',
    value: 'Doctrate (PhD)'
  }
];

const ProfessionDetails = props => {
  const [showFullImage, setShowFullImage] = useState(false);
  const [showOnlyEmploymentDetails, setShowOnlyEmploymentDetails] = useState(
    false
  );
  const [industryType, setIndustryType] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState('');
  const ref = useRef(null);
  const [companyType, setCompanyType] = useState([]);
  const [salaryDocUploads, setSalaryDocUploads] = useState({});
  const [docUploaded, setDocUploaded] = useState(false);
  const [docUploadError, setDocUploadError] = useState(false);
  const [show, setShow] = useState(true);
  const [leadAppicant_Id, setLeadApplicant_Id] = useState('');
  const [lead_Id, setLead_id] = useState('');
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState('');
  const [hasDoc, setHasDoc] = useState(null);
  const [hasExpDoc, setHasExpDoc] = useState('');
  const [hasAppDoc, setHasAppDoc] = useState('');
  const [editApp, setEditApp] = useState(false);
  const [editExp, setEditExp] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [isGetFile, setIsGetFile] = useState(false);
  const [isGstValid, setIsGstValid] = useState(false);
  const [invalidGstMsg, setInvalidGstMsg] = useState(false);
  const [companyGstName, setCompanyGstName] = useState('');
  const { total_experience } = styles;

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    setFieldError,
    validateForm
  } = useFormikContext();

  const applyCondtn = () => {
    if (docUploaded || docUploadError || loading) return true;
  };

  const propsRenderer = () => {
    let props = {};
    if (docUploaded) {
      props.type = 'success';
      props.text = 'Document uploaded successfully';
      props.autoClose = true;
      return props;
    }

    if (docUploadError) {
      props.type = 'fail';
      props.text = 'Error uploading the file, please try again ';
      props.autoClose = true;
      return props;
    }

    if (loading) {
      props.type = 'loading';
      props.text = 'Uploading document. . . ';
      return props;
    }
  };
  //get api
  useEffect(() => {
    if (lead_Id && leadAppicant_Id) {
      getProfessionDetails(lead_Id, leadAppicant_Id)
        .then(res => {
          if (res) {
            setHasDoc(true);
            if (res.appointmentLetter?.links[0]?.url || false) {
              setHasAppDoc(res.appointmentLetter.links[0].url);
            }
            if (res.experienceLetter?.links[0]?.url || false) {
              setHasExpDoc(res.experienceLetter.links[0].url);
            }
            if (
              res.appointmentLetter?.links[0]?.url &&
              res.experienceLetter?.links[0]?.url
            ) {
              setIsGetFile(true);
              setFieldValue('fileRef', false);
            }
            let userData = res;
            setFieldValue('companyName', userData?.companyName || '');
            setFieldValue('companyType', {
              label: userData?.companyTypeName || 'Select Company Type',
              value: userData?.companyTypeId || ''
            });
            setFieldValue('gstCheck', userData?.isGst);
            setFieldValue('gstNo', userData?.gstNumber || '');
            setFieldValue('department', userData?.department || '');
            setFieldValue('designation', userData?.designation || '');
            setFieldValue('email', userData?.companyEmail || '');
            setFieldValue('qualification', {
              value: userData?.highestQualification || '',
              label:
                userData?.highestQualification || 'Select Highest Qualification'
            });

            setFieldValue('industry', {
              value: userData?.industry || '',
              label: userData?.industry || 'Industry'
            });
            if (userData.totalExperience !== null)
              setFieldValue('totalExperienceYear', {
                value: Math.floor(userData.totalExperience / 12),
                label: Math.floor(userData.totalExperience / 12)
              });
            setFieldValue('totalExperienceMonth', {
              value: userData.totalExperience % 12,
              label: userData.totalExperience % 12
            });
            if (userData.currentCompanyExperience !== null)
              setFieldValue('currentCompanyExperienceYear', {
                value: Math.floor(userData.currentCompanyExperience / 12),
                label: Math.floor(userData.currentCompanyExperience / 12)
              });
            setFieldValue('currentCompanyExperienceMonth', {
              value: userData.currentCompanyExperience % 12,
              label: userData.currentCompanyExperience % 12
            });

            setTimeout(() => {
              validateForm();
            }, 1000);
          }
        })
        .catch(err => {});
    }
  }, [lead_Id, leadAppicant_Id]);

  //geting leadId and ApplicantId
  useEffect(() => {
    let leadDetails = getApplicantionInfo();
    const { leadId, leadApplicantId } = leadDetails;
    setLead_id(leadId);
    setLeadApplicant_Id(leadApplicantId);
  }, []);

  //geting industry type
  async function getIndustryOptions() {
    let isError = false;
    const apiRes = await getIndustryTypeProfessionDetail().catch(err => {
      isError = true;
    });
    if (!isError) {
      const makeOptions = apiRes.map(each => {
        return {
          label: each?.name,
          value: each?.name
        };
      });
      setIndustryType(makeOptions);
    }
  }
  useEffect(() => {
    getIndustryOptions();
  }, []);
  //

  useEffect(() => {
    if (docUploadError || docUploaded) setLoading(false);
  }, [docUploaded, docUploadError]);

  //uploading the Experience letter
  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[0] && values.file[0] !== '') {
      setLoading(true);
      EmpDocUpload(
        values.file[0][0],
        lead_Id,
        leadAppicant_Id,
        'experience-letter',
        {
          'Content-Type': `${values.file[0][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[0][0], {
            'Content-Type': `${values.file[0][0].type}`
          })
            .then(res => {
              EmpDocUploaded(
                lead_Id,
                leadAppicant_Id,
                docId,
                'experience-letter'
              )
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({ ...salaryDocUploads, 0: 'uploaded' });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => {
          setDocUploadError(true);
        });
    }
  }, [values.file[0]]);

  // uploading the employement letter
  useEffect(() => {
    setDocUploaded(false);
    setDocUploadError(false);
    setShow(true);
    if (values.file[1] && values.file[1] !== '') {
      setLoading(true);
      EmpDocUpload(
        values.file[1][0],
        lead_Id,
        leadAppicant_Id,
        'appointment-letter',
        {
          'Content-Type': `${values.file[1][0].type}`
        }
      )
        .then(res => {
          let docId = res.requestId;
          UploadFileToS3(res.url, values.file[1][0])
            .then(res => {
              EmpDocUploaded(
                lead_Id,
                leadAppicant_Id,
                docId,
                'appointment-letter'
              )
                .then(res => {
                  setDocUploaded(true),
                    setSalaryDocUploads({
                      ...salaryDocUploads,
                      1: 'uploaded'
                    });
                })
                .catch(err => setDocUploadError(true));
            })
            .catch(err => setDocUploadError(true));
        })
        .catch(err => setDocUploadError(true));
    }
  }, [values.file[1]]);

  useEffect(() => {
    validateForm();
    if (
      values.file[0] &&
      values.file[1] &&
      values.file[0] !== '' &&
      values.file[1] !== ''
    ) {
      setShowFullImage(true);
    }
  }, [values.file]);
  // validating upload criteria
  useEffect(() => {
    if (
      values.currentCompanyExperienceYear.value * 12 +
        values.currentCompanyExperienceMonth.value <
      6
    ) {
      if (!isGetFile) {
        setFieldValue('fileRef', true, true);
      }
      setShowUpload(true);
    } else {
      setShowUpload(false);
      setFieldValue('fileRef', false);
    }
  }, [
    values.currentCompanyExperienceYear,
    values.currentCompanyExperienceMonth
  ]);

  function getYearExperienceError() {
    if (
      values.totalExperienceYear.value !== '' &&
      values.totalExperienceMonth.value !== '' &&
      values.currentCompanyExperienceMonth.value !== '' &&
      values.currentCompanyExperienceYear.value !== ''
    ) {
      let totalExperience =
        values.totalExperienceYear.value +
        values.totalExperienceMonth.value / 12;
      let currentcompany =
        values.currentCompanyExperienceYear.value +
        values.currentCompanyExperienceMonth.value / 12;

      return totalExperience < currentcompany;
    }
    return false;
  }

  const checkGstValidation = async gstNo => {
    await getCompanyNameByGst(gstNo).then(res => {
      if (res) {
        setCompanyGstName(res);
        setInvalidGstMsg(false);
        setIsGstValid(true);
      } else {
        setCompanyGstName('');
        if (values.gstCheck && values.gstNo.length === 15) {
          setInvalidGstMsg(true);
          setIsGstValid(false);
        } else {
          setInvalidGstMsg(false);
          setIsGstValid(true);
        }
      }
    });
  };

  useEffect(() => {
    setInvalidGstMsg(false);
    setCompanyGstName('');
    if (values.gstNo) {
      checkGstValidation(values.gstNo);
    }
  }, [values.gstNo]);

  const onSubmitHandler = async () => {
    const leadData = await getApplicantionInfo();
    if (!values.gstCheck || isGstValid) {
      setInvalidGstMsg(false);
      await submitDetails(leadData.leadId, leadData.leadApplicantId, {
        highestQualificationId: 0,
        highestQualification: values.qualification.label,
        companyEmail: values.email,
        companyName: selectedCompany || values.companyName,
        companyTypeId: values.companyType.value,
        industryType: 0,
        industry: values.industry.value,
        department: values.department,
        designation: values.designation,
        gstNumber: values.gstCheck ? values.gstNo : '',
        isGst: values.gstCheck && values.gstNo ? true : false,
        saveRiskName: values.gstCheck ? companyGstName : '',
        totalExperience:
          values.totalExperienceYear.value * 12 +
          values.totalExperienceMonth.value,
        currentCompanyExperience:
          values.currentCompanyExperienceYear.value * 12 +
          values.currentCompanyExperienceMonth.value
      })
        .then(res => {
          handleSubmit();
        })
        .catch(err => {
          setShowError(err?.response?.data?.message || '');
        });
    } else {
      setInvalidGstMsg(true);
    }
  };

  const companyChange = e => {
    setCompanyOptions([]);
    setSelectedCompany(e.target.value);
  };

  useEffect(() => {
    setCompanyOptions([]);
    setShowCompanyOptions(false);
    let companies = [];
    getCompanies(selectedCompany).then(res => {
      res.map(each => {
        return companies.push({ value: each.name, label: each.name });
      });
      setCompanyOptions(companies);
      if (companies.length > 0) {
        setShowCompanyOptions(true);
      }
    });
  }, [selectedCompany]);

  useEffect(() => {
    getCompanyTypeList().then(res => {
      const options = res.map(each => {
        return {
          label: each?.name,
          value: each?.id
        };
      });
      setCompanyType(options);
    });
  }, []);

  useEffect(() => {
    function handleOutsideClick(event) {
      setShowCompanyOptions(true);
      if (ref.current && !ref.current.contains(event.target)) {
        setShowCompanyOptions(false);
      }
    }

    document.addEventListener('click', handleOutsideClick);
    return () => document.removeEventListener('click', handleOutsideClick);
  }, [ref]);

  const isYearExperienceError = getYearExperienceError();

  return (
    <>
      {applyCondtn() && (
        <PopUp {...propsRenderer()} setShow={setShow} show={show} />
      )}
      <div className="p-5">
        {/* professional details */}
        {!showOnlyEmploymentDetails ? (
          <>
            <div
              className=" m-2 md:mx-auto py-10 md:py-0
                  bg-transparent "
            >
              <h2 className="font-roboto font-medium text-lg text-black-500 mb-5">
                Professional Details
              </h2>
              <div className="flex flex-col xl:flex-row gap-x-10 flex-wrap ">
                <div className="w-full xl:w-9/20">
                  {hasDoc ? (
                    <label className="text-xs text-grey-50 -mt-2.5 z-20 bg-white absolute ml-4 block">
                      Highest Qualification
                    </label>
                  ) : null}
                  <CommonSelect
                    sort={true}
                    name="qualification"
                    value={values.qualification}
                    onChange={anyvalue => {
                      setFieldValue('qualification', anyvalue, true);
                      setFieldTouched('qualification', true, false);
                    }}
                    onBlur={() => {
                      setFieldTouched('qualification', true, true);
                    }}
                    options={[
                      {
                        label: 'Select Highest Qualification',
                        value: ''
                      },
                      ...qualificationOption
                    ]}
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '40px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched.qualification &&
                      get(errors, 'qualification.value', false)
                    }
                    errorMsg={get(errors, 'qualification.value', false)}
                    touched={touched.qualification}
                  />
                </div>
                <div ref={ref} className="w-full xl:w-9/20 relative">
                  <CommonInput
                    name="companyName"
                    onChange={e => {
                      handleChange(e);
                      companyChange(e);
                      setFieldValue('companyName', e.target.value);
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                    value={selectedCompany || values.companyName}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%',
                      marginBottom: '40px'
                    }}
                    legendName="Company Name"
                    error={touched.companyName && errors.companyName}
                    errorMsg={errors.companyName}
                    touched={touched.companyName}
                  />
                  {showCompanyOptions && companyOptions.length > 0 && (
                    <div
                      style={{ maxHeight: '140px' }}
                      className={`${
                        showCompanyOptions === true
                          ? 'w-full all_dropdown block overflow-y-scroll py-1 z-20 absolute top-1/2 rounded mt-2 ml-px opacity-100 bg-grey-1002 shadow-lg'
                          : 'hidden'
                      }`}
                    >
                      {companyOptions.map((each, i) => (
                        <div key={`company${i}`} className="relative">
                          <p
                            className="text-black-600 mt-1 cursor-pointer pl-1 opacity-100"
                            onClick={() => {
                              setSelectedCompany(each.value);
                              setShowCompanyOptions(false);
                            }}
                          >
                            {each.label}
                          </p>
                          <span
                            className={`${
                              selectedCompany === each.label
                                ? `text-green-600 font-medium`
                                : `hidden`
                            }`}
                          >
                            ✓
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className="w-full xl:w-9/20">
                  <label className="text-xs text-grey-50 -mt-2.5 z-10 bg-white absolute ml-4 block">
                    Company Type
                  </label>
                  <CommonSelect
                    sort={true}
                    name="companyType"
                    value={values.companyType}
                    onChange={anyvalue => {
                      setFieldValue('companyType', anyvalue, true);
                      setFieldTouched('companyType', true, false);
                    }}
                    onBlur={() => {
                      setFieldTouched('companyType', true, true);
                    }}
                    options={[
                      {
                        label: 'Select Company Type',
                        value: ''
                      },
                      ...companyType
                    ]}
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '40px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched.companyType &&
                      get(errors, 'companyType.value', false)
                    }
                    errorMsg={get(errors, 'companyType.value', false)}
                    touched={touched.companyType}
                  />
                </div>
                <div className="w-full xl:w-9/20">
                  {/* ///////////emailid */}
                  <CommonInput
                    name="email"
                    onChange={e => {
                      handleChange(e);
                      setFieldValue('email', e.target.value);
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                    value={values.email}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%',
                      marginBottom: '40px'
                    }}
                    legendName="Official Email ID"
                    error={touched.email && errors.email}
                    errorMsg={errors.email}
                    touched={touched.email}
                  />
                </div>
                <div className="w-full xl:w-9/20">
                  <CommonInput
                    name="department"
                    onChange={e => {
                      handleChange(e);
                      setFieldValue('department', e.target.value);
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                    value={values.department}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%',
                      marginBottom: '40px'
                    }}
                    legendName="Department"
                    error={touched.department && errors.department}
                    errorMsg={errors.department}
                    touched={touched.department}
                  />
                </div>
                <div className="w-full xl:w-9/20">
                  <CommonInput
                    name="designation"
                    onChange={e => {
                      handleChange(e);
                      setFieldValue('designation', e.target.value);
                    }}
                    onBlur={e => {
                      handleBlur(e);
                    }}
                    value={values.designation}
                    stylesContainer={{
                      height: '52px',
                      maxWidth: '100%',
                      marginBottom: '40px'
                    }}
                    legendName="Designation"
                    error={touched.designation && errors.designation}
                    errorMsg={errors.designation}
                    touched={touched.designation}
                  />
                </div>

                {/* //////////industry */}
                <div className="w-full xl:w-9/20">
                  {hasDoc ? (
                    <label className="text-xs text-grey-50 -mt-2.5 z-10 bg-white absolute ml-4 block">
                      Industry
                    </label>
                  ) : null}
                  <CommonSelect
                    sort={true}
                    name="industry"
                    value={values.industry}
                    onChange={anyvalue => {
                      setFieldValue('industry', anyvalue, true);
                      setFieldTouched('industry', true, false);
                    }}
                    onBlur={() => {
                      setFieldTouched('industry', true, true);
                    }}
                    options={[
                      {
                        label: 'Choose Industry ',
                        value: ''
                      },
                      ...industryType
                    ]}
                    stylesContainer={{
                      height: '52px',
                      marginBottom: '40px',
                      fontSize: '40px'
                    }}
                    dropdownStyle={{
                      top: '55px'
                    }}
                    styleText={{
                      fontSize: '14px',
                      padding: '0 25px'
                    }}
                    error={
                      touched.industry && get(errors, 'industry.value', false)
                    }
                    errorMsg={get(errors, 'industry.value', false)}
                    touched={touched.industry}
                  />
                </div>
                <div className="w-full md:flex block pb-3">
                  <div className="font-roboto font-medium text-sm text-black-500">
                    Do you have GST Number ?
                  </div>
                  <div className="flex-row-reverse flex md:flex-row  py-2 md:py-0 md:ml-5">
                    <RadioButton
                      name="gstCheck"
                      checked={values.gstCheck}
                      onChange={e => {
                        handleChange(e), setFieldValue('gstCheck', true);
                      }}
                      onBlur={handleBlur}
                    />
                    <p className="font-roboto font-normal text-grey-2000 md:px-2 mr-auto">
                      Yes
                    </p>
                  </div>
                  <div className="mr-auto flex md:ml-5 flex-row-reverse md:flex-row py-2 md:py-0">
                    <RadioButton
                      name="gstCheck"
                      checked={!values.gstCheck}
                      onChange={e => {
                        handleChange(e), setFieldValue('gstCheck', false);
                      }}
                      onBlur={handleBlur}
                    />
                    <p className="font-roboto font-normal text-grey-2000 md:px-3 mr-auto">
                      No
                    </p>
                  </div>
                </div>
                {values.gstCheck && (
                  <div className="w-full xl:w-9/20 relative">
                    <CommonInput
                      name="gstNo"
                      onChange={e => {
                        handleChange(e);
                        setFieldValue('gstNo', e.target.value);
                      }}
                      onBlur={e => {
                        handleBlur(e);
                      }}
                      value={values.gstNo}
                      stylesContainer={{
                        height: '52px',
                        maxWidth: '100%',
                        marginBottom: '40px'
                      }}
                      legendName="GST Number"
                      error={touched.gstNo && errors.gstNo}
                      errorMsg={errors.gstNo}
                      touched={touched.gstNo}
                    />
                    {companyGstName && (
                      <div className="absolute top-1/2 mt-2 text-sm text-black-500 font-roboto">
                        <span className="font-medium">{companyGstName}</span>
                        <span className="">{` is registered with this GST Number.`}</span>
                      </div>
                    )}
                  </div>
                )}
                {invalidGstMsg && (
                  <Modal
                    show={invalidGstMsg}
                    setShow={setInvalidGstMsg}
                    title={'Please enter a valid GST number.'}
                  />
                )}
              </div>
            </div>
            <div className="block md:hidden">
              <button
                disabled={
                  errors.qualification ||
                  errors.companyName ||
                  errors.companyType ||
                  errors.gstNo ||
                  errors.email ||
                  errors.industry ||
                  errors.designation ||
                  errors.department
                }
                className="submitButton w-56"
                onClick={() => setShowOnlyEmploymentDetails(true)}
              >
                next
              </button>
            </div>
          </>
        ) : null}

        {/* employment details */}
        <div className={showOnlyEmploymentDetails ? '' : 'hidden md:block'}>
          <h2 className="font-roboto font-medium text-sm text-black-500 mb-3 mt-6">
            Employement Details
          </h2>
          {/* //////////experience */}
          <div className="mb-7 xl:mb-0">
            <div className="pb-2 text-sm text-black-100 font-normal font-roboto">
              Total Years of Experience
            </div>

            <div className={`${total_experience}`}>
              <CommonSelect
                name="totalExperience"
                value={values.totalExperienceYear}
                onChange={anyvalue => {
                  setFieldValue('totalExperienceYear', anyvalue, true);
                  setFieldTouched('totalExperienceYear', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('totalExperienceYear', true, true);
                }}
                options={[
                  {
                    label: 'Year',
                    value: ''
                  },
                  ...Salary_experience_year(2)
                ]}
                stylesContainer={{
                  height: '52px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  (touched.totalExperienceYear &&
                    get(errors, 'totalExperienceYear.value', false)) ||
                  isYearExperienceError
                }
                errorMsg={get(errors, 'totalExperienceYear.value', false)}
                touched={touched.totalExperienceYear}
              />
              {/* ///////////// */}
              <CommonSelect
                name="totalExperience"
                value={values.totalExperienceMonth}
                onChange={anyvalue => {
                  setFieldValue('totalExperienceMonth', anyvalue, true);
                  setFieldTouched('totalExperienceMonth', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('totalExperienceMonth', true, true);
                }}
                options={[
                  {
                    label: 'Month',
                    value: ''
                  },
                  ...Salary_experience_month()
                ]}
                stylesContainer={{
                  height: '52px',

                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  (touched.totalExperienceMonth &&
                    get(errors, 'totalExperienceMonth.value', false)) ||
                  isYearExperienceError
                }
                errorMsg={get(errors, 'totalExperienceMonth.value', false)}
                touched={touched.totalExperienceMonth}
              />
            </div>
            {isYearExperienceError ? (
              <p className="text-red-300 pt-2 text-xs">
                Current Year exp. cannot be greater than total experience
              </p>
            ) : (
              ''
            )}
          </div>
          {/* //////////current experience */}
          <div>
            <div className="pb-2 text-sm text-black-100 font-normal font-roboto">
              Time in Current Company
            </div>

            <div className={`${total_experience}`}>
              <CommonSelect
                name="currentCompanyExperience"
                value={values.currentCompanyExperienceYear}
                onChange={anyvalue => {
                  setFieldValue('currentCompanyExperienceYear', anyvalue, true);
                  setFieldTouched('currentCompanyExperienceYear', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('currentCompanyExperienceYear', true, true);
                }}
                options={[
                  {
                    label: 'Year',
                    value: ''
                  },
                  ...Salary_experience_year()
                ]}
                stylesContainer={{
                  height: '52px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  touched.currentCompanyExperienceYear &&
                  get(errors, 'currentCompanyExperienceYear.value', false)
                }
                errorMsg={get(
                  errors,
                  'currentCompanyExperienceYear.value',
                  false
                )}
                touched={touched.currentCompanyExperienceYear}
              />
              {/* ///////////// */}
              <CommonSelect
                name="currentCompanyExperience"
                value={values.currentCompanyExperienceMonth}
                onChange={anyvalue => {
                  setFieldValue(
                    'currentCompanyExperienceMonth',
                    anyvalue,
                    true
                  );
                  setFieldTouched('currentCompanyExperienceMonth', true, false);
                }}
                onBlur={() => {
                  setFieldTouched('currentCompanyExperienceMonth', true, true);
                }}
                options={[
                  {
                    label: 'Month',
                    value: ''
                  },
                  ...Salary_experience_month()
                ]}
                stylesContainer={{
                  height: '52px',
                  marginBottom: '40px',
                  fontSize: '40px'
                }}
                dropdownStyle={{
                  top: '55px'
                }}
                styleText={{
                  fontSize: '14px',
                  padding: '0 25px'
                }}
                error={
                  touched.currentCompanyExperienceMonth &&
                  get(errors, 'currentCompanyExperienceMonth.value', false)
                }
                errorMsg={get(
                  errors,
                  'currentCompanyExperienceMonth.value',
                  false
                )}
                touched={touched.currentCompanyExperienceMonth}
              />
            </div>
          </div>

          {/* ///////upload here /////////*/}
          {showUpload && (
            <div className="pre_emp_upload">
              <div className="pb-4 text-base text-black-600 font-medium">
                Please provide for previous employer
              </div>

              <div className="flex flex-row flex-wrap justify-around w-full ">
                <div className="w-64 mt-3  md:w-auto bg-white md:bg-transparent pb-7 md:pb-0 rounded-md md:rounded-none border border-blue-1100 md:border-none">
                  {hasExpDoc && !editExp ? (
                    <div className="ml-2 mt-2">
                      <p className="mb-3 text-grey-50 ">Relieving letter </p>
                      <ShowGetImage img={hasExpDoc} setEdit={setEditExp} />
                    </div>
                  ) : (
                    <div className="ml-2 mt-2">
                      <p className="mb-3 text-grey-50 ">Relieving letter </p>
                      <GlobalUploadComp
                        data={values}
                        imgIndex={0} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage={showFullImage} // boolean , to change mobile upload image view
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload"
                        subtext="CHOOSE FILE"
                      />
                    </div>
                  )}
                </div>

                <div className="w-64 mt-3 md:w-auto bg-white md:bg-transparent pb-7 md:pb-0 rounded-md md:rounded-none border border-blue-1100 md:border-none">
                  {hasAppDoc && !editApp ? (
                    <div className="ml-2 mt-2">
                      <p className="mb-3 text-grey-50">Offer Letter</p>
                      <ShowGetImage img={hasAppDoc} setEdit={setEditApp} />
                    </div>
                  ) : (
                    <div className="ml-2 mt-2">
                      <p className="mb-3 text-grey-50">Offer Letter</p>
                      <GlobalUploadComp
                        data={values}
                        imgIndex={1} //0,1,2,3 depending upon the no of file sequence
                        errors={errors}
                        touched={touched}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        setFieldError={setFieldError}
                        showFullImage={showFullImage} // boolean , to change mobile upload image view
                        initialImg={initialImg} // initial image
                        subInst="Click here to upload"
                        subtext="CHOOSE FILE"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div
          className={
            (showOnlyEmploymentDetails ? 'block' : 'hidden md:block') + ' mt-20'
          }
        >
          <button
            onClick={onSubmitHandler}
            disabled={!_.isEmpty(errors)}
            className="submitButton w-56 lg:w-80 font-semibold "
            type="button"
            id="submit"
          >
            CONTINUE
          </button>
          <p className="text-red-100 my-2 text-center text-base">{showError}</p>
        </div>
      </div>
    </>
  );
};
export default ProfessionDetails;
